const devtricker_reportedPosts = {};

async function devtricker_reportPost(event, element) {
    event.preventDefault();
    event.stopPropagation();

    let userId = devtricker_getTheLoggedUserId();

    if (!userId) {
        devtricker_openSocialLoginModal();
        return;
    }

    let postId = element.getAttribute('data-post-id');

    const originalHTML = '<span class=" icon icon-flag " ></span> <span class="ms-2">Report</span>';
    const successHTML = '<span class=" icon icon-check " ></span> <span class="ms-2">Reported!</span>';
    const errorHTML = ' <span class=" icon icon-x " ></span> <span class="ms-2">Error!</span>';
    
    if (!devtricker_reportedPosts[postId]) {

        element.innerHTML = successHTML;

        devtricker_reportedPosts[postId] = await devtricker_ajax_reportPost(postId);

        if (!devtricker_reportedPosts[postId]) {
            element.innerHTML = errorHTML;
        }
    } else {
        element.innerHTML = successHTML;
    }

    setTimeout(() => {
        element.innerHTML = originalHTML;
    }, 3000);
}
